import { render, staticRenderFns } from "./NavMenuManager.vue?vue&type=template&id=025bd172&scoped=true&"
import script from "./NavMenuManager.vue?vue&type=script&lang=js&"
export * from "./NavMenuManager.vue?vue&type=script&lang=js&"
import style0 from "./NavMenuManager.vue?vue&type=style&index=0&id=025bd172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025bd172",
  null
  
)

export default component.exports